module.exports = __webpack_public_path__ + "img/CoActiveCare_logo_light_600.4e841cb2.png";